import React from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap'
import BannerForm from '../../common/BannerForm';
export default function HeroSections() {


    return (
        <>
            <section className='nft_heroSections'>
                <Container>
                    <Row>
                        <Col sm={6} md={6} lg={8} xl={8}>
                            <div className='nftHero-about-wrap'>
                                <h2 className='h2_title'>Top AngularJS Development Company</h2>
                                <p>Infograins, your trusted partner for AngularJS development services. AngularJS is an advanced front-end JavaScript framework that can make your web applications more dynamic, responsive, and user-friendly. Our skilled AngularJS developers are available to assist you in realizing the full potential of this cutting-edge technology.</p>
                            </div>
                        </Col>
                        <Col sm={6} md={6} lg={4} xl={4}>
                            <BannerForm />
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
